import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LitigationStatusLabel } from './litigation-status-icon-chip.model';

@Component({
    selector: 'ifm-litigation-status-icon-chip',
    templateUrl: './litigation-status-icon-chip.component.html',
    styleUrls: ['./litigation-status-icon-chip.component.scss'],
    standalone: false
})
export class LitigationStatusIconChipComponent implements OnChanges {
  
  @Input()
  status = 'open';
  
  @Input()
  tooltip: string;

  statusLabels: LitigationStatusLabel
  
  ngOnChanges(_: SimpleChanges): void {
    this.initStatusLabels();
  }

  private initStatusLabels() {
    this.statusLabels = {
      'pending': { color: 'white-background __gray-icon', icon: 'help', label: 'Pending' },
      'approved': { color: 'white-background __green-icon', icon: 'check_circle', label: 'Approved' },
      'needs-attention': { color: 'white-background __orange-icon', icon: 'warning', label: 'Needs attention', tooltipMsg: this.tooltip },
      'declined': { color: 'white-background __purple-icon', icon: 'warning', label: 'Declined' },
      'payment-due': { color: 'white-background __orange-icon', icon: 'payments', label: 'Payment Due'}
    };
  }
}
